<template>
  <div>
    <v-alert
      v-if="!channelState.isProviderConfigured"
      type="warning"
      text
      dense
    >
      Не настроен<span v-if="channelState.providerNote">: {{ channelState.providerNote }}</span>
    </v-alert>

    <div class="d-flex align-center flex-wrap">
      <v-chip
        v-if="channelState.isProviderConfigured"
        small
        color="success"
        text-color="white"
        class="me-3 mb-2"
      >
        Провайдер настроен
      </v-chip>
      <v-chip
        v-if="channelState.isSandbox"
        small
        color="warning"
        text-color="white"
        class="me-3 mb-2"
      >
        Режим стенда
      </v-chip>
      <span
        v-if="devices"
        class="me-6 mb-2"
      >
        <span class="text--secondary">Активных устройств:</span> {{ channelState.activeDevices }}
      </span>
      <span class="mb-2">
        <span class="text--secondary">Последняя успешная отправка:</span>
        {{ toDateTimeString(channelState.lastSentAt) || 'ещё не было' }}
      </span>
    </div>

    <div
      v-if="channelState.lastError"
      class="error--text"
    >
      Последняя ошибка<span v-if="channelState.lastErrorAt">, {{ toDateTimeString(channelState.lastErrorAt) }}</span>:
      {{ channelState.lastError }}
    </div>
  </div>
</template>

<script>
import { toDateTimeString } from '@/helpers'

export default {
  name: 'ChannelState',

  props: {
    channelState: { type: Object, required: true },
    devices: Boolean,
  },
  data: () => ({
    toDateTimeString,
  }),
}
</script>
